<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list ref="violationTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="clearWeight" slot-scope="data">
          <span v-if="data.row.clearWeight !== 0">{{ data.row.clearWeight }}</span>
        </template>
        <template slot="tableTopCustom">
          <div class="table-list-desc">箱体收益{{form.formResult.sum}} 元</div>
        </template>
      </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>

export default {
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_RECYCLINGMONEY_LIST',
        formComponent: {
          list: { type: 'default', value: '/modules/ablHardwareStats/dataList' }
        },
        formInputsData: [],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/ablHardwareStats/exportExcel',
          fileName: '箱体收益',
          permission: 'EXPORT' }],
        formTableData: [
          { name: '箱体名称', key: 'boxName', type: 'text' },
          { name: '公司名称', key: 'companyName' },
          { name: 'SN', key: 'sn', type: 'text' },
          { name: '清运重量', key: 'clearWeight', type: 'custom' },
          { name: '清运金额(元)', key: 'collectorTotalPayment', type: 'text' },
          { name: '分润金额(元)', key: 'netProfit' },
          { name: '分润时间', key: 'statsDate', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, buttonHidden: true, index: false }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        // if (data.item.action === 'VIEW' || data.item.action === 'EDIT') {
        // this.$store.dispatch('setLopperDetailData', data.row)
        // }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.table-list-desc {
  padding: 20px;
  color: #333333;
  font-size: 14px;
}
</style>
